import { request } from '@/shared/api/request'
export const getPersonList = () => {
	return request({ url: 'proactive/personList', method: 'GET' })
}
